<template>
  <el-dialog
    class="rc-dialog"
    title="关联试卷"
    :visible.sync="dialogVisible"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-table :data="list" stripe>
      <el-table-column prop="paperName">
        <template slot="header"> </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getPaperList } from "@/api/examQuestion";
import vue from "@/main";
export default {
  data() {
    return {
      dialogVisible: false,
      list: []
    };
  },
  created() {
    vue.$on("previewPaper", id => {
      this.dialogVisible = true;
      this.getData(id);
    });
  },
  methods: {
    getData(id) {
      getPaperList(id).then(res => {
        if (!res || res.code != 0) return;
        this.list = res.data;
      });
    }
  },
  beforeDestroy() {
    vue.$off("previewPaper");
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 300px;
  }
  /deep/ .el-table__header-wrapper {
    height: 0;
    display: hidden;
  }
}
</style>
